import { definePropType } from "./props";
import type { Component } from "vue";

export const iconPropType = definePropType<string | Component>([
	String,
	Object,
	Function
])
